import WidgetSearchRequest from '../api/WidgetSearchRequest.js';
export default (rfkId) => {
    const request = new WidgetSearchRequest(rfkId);
    request.setRecommendationsContent({});
    return request;
};
